import { createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "body2-text brg-color-grey-600 d-flex align-center" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_icon = _resolveComponent("v-icon");
    const _component_v_tooltip = _resolveComponent("v-tooltip");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createCommentVNode("\n    관련 논의\n    https://barogo.slack.com/archives/C02GJBMBU6B/p1677136880052999?thread_ts=1677132013.533209&cid=C02GJBMBU6B\n   "),
        _createVNode(_component_v_tooltip, {
            modelValue: _ctx.isActive,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.isActive) = $event)),
            right: !_ctx.isLeftPosition,
            left: _ctx.isLeftPosition,
            transition: "fade-transition",
            "content-class": _ctx.contentClass
        }, {
            activator: _withCtx(({ props }) => [
                _createElementVNode("span", _mergeProps({ class: _ctx.dottedTooltipActivatorClass }, props), [
                    _renderSlot(_ctx.$slots, "activatorSlot", {}, undefined, true)
                ], 16 /* FULL_PROPS */)
            ]),
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    (!_ctx.withoutIcon)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            dense: "",
                            class: "mr-2"
                        }, {
                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                                _createTextVNode(" mdi-information-outline ")
                            ])),
                            _: 1 /* STABLE */,
                            __: [1]
                        }))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("span", null, [
                        _renderSlot(_ctx.$slots, "tooltipMessage", {}, undefined, true)
                    ])
                ])
            ]),
            _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["modelValue", "right", "left", "content-class"])
    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */));
}
